import(/* webpackMode: "eager" */ "/usr/src/app/src/app/news/news.css");
;
import(/* webpackMode: "eager", webpackExports: ["WebviewInitializer"] */ "/usr/src/app/src/components/common/webview-initializer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/configs/registry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/scripts/gtmScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InitialiseAckoAnalytics"] */ "/usr/src/app/src/utils/InitializeAcko.tsx");
